import type { Responsive } from '#types/common'

/**
 * Resolves the value for a given breakpoint from a responsive value object.
 * Falls back from the requested breakpoint → `md` → `sm`. If the input is not a `Responsive<T>`
 * object it is returned as-is (treating scalar values as breakpoint-agnostic).
 * @template T - The wrapped value type.
 * @param br - The target breakpoint (e.g. `'sm'`, `'md'`, `'lg'`).
 * @param obj - Either a scalar value or a `Responsive<T>` map.
 * @returns The breakpoint value with fallbacks applied, or `undefined` when nothing matches.
 * @category Utils
 */
export const getValueForBreakpoint = <T>(br: keyof Responsive, obj?: T | Responsive<T>): T | undefined =>
  isObject(obj) ? (obj[br] ?? obj.md ?? obj.sm) : obj
